import { HTMLProps } from 'react';

import Navbar from './Navbar';

export interface NavbarProps extends HTMLProps<HTMLDivElement> {
	appName?: string;
}

export default Navbar;